(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8905],{

/***/ 41219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Uu": function() { return /* binding */ MONTH_SHORT_FORMS; },
/* harmony export */   "gg": function() { return /* binding */ MONTHS; },
/* harmony export */   "z1": function() { return /* binding */ DAYS; }
/* harmony export */ });
/* unused harmony export VIEWS */
var MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December", 
];
var MONTH_SHORT_FORMS = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec", 
];
var DAYS = [
    "Su",
    "Mo",
    "Tu",
    "We",
    "Th",
    "Fr",
    "Sa"
];
var VIEWS = {
    DATES: "date",
    MONTH: "month",
    YEAR: "year"
};


/***/ }),

/***/ 1165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DK": function() { return /* binding */ handleBrowserBack; },
/* harmony export */   "Fw": function() { return /* binding */ calculateAge; },
/* harmony export */   "Jw": function() { return /* binding */ getDomainHostname; },
/* harmony export */   "L0": function() { return /* binding */ getTravellersLabel; },
/* harmony export */   "L6": function() { return /* binding */ getTripDurationLabel; },
/* harmony export */   "So": function() { return /* binding */ getYear; },
/* harmony export */   "ZH": function() { return /* binding */ getSessionQuery; },
/* harmony export */   "Zu": function() { return /* binding */ getLabelWithCount; },
/* harmony export */   "bV": function() { return /* binding */ getAtlPrice; },
/* harmony export */   "jw": function() { return /* binding */ getMonth; },
/* harmony export */   "kp": function() { return /* binding */ convertDateRange; },
/* harmony export */   "m4": function() { return /* binding */ getImageBasePath; },
/* harmony export */   "pI": function() { return /* binding */ getDurationString; },
/* harmony export */   "rf": function() { return /* binding */ redirectToLogin; },
/* harmony export */   "vl": function() { return /* binding */ getQueryParams; },
/* harmony export */   "xN": function() { return /* binding */ convertDateToString; },
/* harmony export */   "yd": function() { return /* binding */ getFormattedDates; }
/* harmony export */ });
/* unused harmony exports getLabel, convertDateFormat, getCountriesString, getSegmentCountries, getUserType, inputRegexValidation */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _segment_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19659);
/* harmony import */ var _api_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66725);
/* harmony import */ var src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56073);
/* harmony import */ var src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41219);







var getImageBasePath = function(imagePath) {
    var imageStaticPath =  true ? "https://internet-travel-retail-frontend.ackoassets.com/next_assets".split("/next_assets")[0] : 0;
    var basePath = imageStaticPath ? "".concat(imageStaticPath, "/_next_static") : "/_next_static";
    if (basePath === "/_next_static") {
        return imagePath;
    }
    return "".concat(basePath).concat(imagePath);
};
var getLabel = function() {
    var label = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", selectedCountries = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var length = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.length;
    if (length > 0) {
        var ref;
        var filtered = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.filter(function(_, i) {
            return i < 2;
        });
        label = (ref = filtered === null || filtered === void 0 ? void 0 : filtered.map(function(param) {
            var name = param.name;
            return name;
        })) === null || ref === void 0 ? void 0 : ref.join(", ");
        if (length > 2) return label.concat(" and ".concat(length - 2, " more"));
    }
    return label;
};
var getLabelWithCount = function() {
    var selectedCountries = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], count = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var label = "";
    var length = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.length;
    if (length > 0) {
        var ref;
        var filtered = selectedCountries === null || selectedCountries === void 0 ? void 0 : selectedCountries.filter(function(_, i) {
            return i < count;
        });
        label = (ref = filtered === null || filtered === void 0 ? void 0 : filtered.map(function(param) {
            var name = param.name;
            return name;
        })) === null || ref === void 0 ? void 0 : ref.join(", ");
        if (length > count) return label.concat(" +".concat(length - count));
    }
    return label;
};
var getTravellersLabel = function() {
    var adultCount = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, seniorCitizenCount = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, childCount = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    var stringList = [];
    var adultString = adultCount > 0 ? adultCount > 1 ? "".concat(adultCount, " ").concat(src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__/* .Category.ADULT */ .WD.ADULT, "s") : "".concat(adultCount, " ").concat(src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__/* .Category.ADULT */ .WD.ADULT) : "";
    if (adultString) stringList === null || stringList === void 0 ? void 0 : stringList.push(adultString);
    var childString = childCount > 0 ? childCount > 1 ? "".concat(childCount, " ").concat(src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__/* .Category.CHILDREN */ .WD.CHILDREN) : "".concat(childCount, " ").concat(src_international_insurance_config__WEBPACK_IMPORTED_MODULE_3__/* .Category.CHILD */ .WD.CHILD) : "";
    if (childString) stringList === null || stringList === void 0 ? void 0 : stringList.push(childString);
    var seniorString = seniorCitizenCount > 0 ? seniorCitizenCount > 1 ? "".concat(seniorCitizenCount, " senior citizens") : "".concat(seniorCitizenCount, " senior citizen") : "";
    if (seniorString) stringList === null || stringList === void 0 ? void 0 : stringList.push(seniorString);
    return stringList === null || stringList === void 0 ? void 0 : stringList.join(", ");
};
var convertDateFormat = function(date) {
    var formattedDate = moment(date).format("DD-MM-YYYY");
    return formattedDate;
};
var getCountriesString = function() {
    var countries = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var ref, ref1;
    var names = (ref = countries === null || countries === void 0 ? void 0 : countries.map(function(c) {
        return c === null || c === void 0 ? void 0 : c.name;
    })) === null || ref === void 0 ? void 0 : ref.join(", ");
    if ((names === null || names === void 0 ? void 0 : names.length) > 30) return (ref1 = names === null || names === void 0 ? void 0 : names.substring(0, 30)) === null || ref1 === void 0 ? void 0 : ref1.concat("...");
    return names;
};
var getDurationString = function(start, end) {
    var nStart = moment__WEBPACK_IMPORTED_MODULE_0___default()(start, "DD-MM-YYYY").format("D MMM YYYY");
    var nEnd = moment__WEBPACK_IMPORTED_MODULE_0___default()(end, "DD-MM-YYYY").format("D MMM YYYY");
    if ((nStart === null || nStart === void 0 ? void 0 : nStart.slice(-4)) === (nEnd === null || nEnd === void 0 ? void 0 : nEnd.slice(-4))) {
        var length = nStart === null || nStart === void 0 ? void 0 : nStart.length;
        nStart = nStart === null || nStart === void 0 ? void 0 : nStart.slice(0, length - 5);
    }
    return "".concat(nStart, " - ").concat(nEnd);
};
var getSegmentCountries = function(list) {
    if ((list === null || list === void 0 ? void 0 : list.length) > 0) {
        var ref;
        if ((list === null || list === void 0 ? void 0 : list.length) > 1) {
            var ref1;
            var c = (ref1 = list === null || list === void 0 ? void 0 : list.map(function(c) {
                return c === null || c === void 0 ? void 0 : c.name;
            })) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 2);
            return c === null || c === void 0 ? void 0 : c.join(", ");
        }
        return (ref = list[0]) === null || ref === void 0 ? void 0 : ref.name;
    }
    return "";
};
var calculateAge = function(dob) {
    var ageDifMs = Date.now() - moment__WEBPACK_IMPORTED_MODULE_0___default()(dob, "DD-MM-YYYY").toDate().getTime();
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
};
var getUserType = function(t) {
    if ((t === null || t === void 0 ? void 0 : t.length) > 0) {
        var ages = t === null || t === void 0 ? void 0 : t.map(function(param) {
            var dob = param.dob;
            return dob ? calculateAge(dob) : null;
        });
        var seniorCitizen = ages === null || ages === void 0 ? void 0 : ages.filter(function(a) {
            return a >= 60;
        });
        return (seniorCitizen === null || seniorCitizen === void 0 ? void 0 : seniorCitizen.length) > 0 ? "senior_citizen" : "";
    }
    return "";
};
var handleBrowserBack = function(router, handleBack) {
    if (!!router) {
        router === null || router === void 0 ? void 0 : router.beforePopState(function(param) {
            var as = param.as;
            if (as !== (router === null || router === void 0 ? void 0 : router.asPath)) {
                handleBack();
                return false;
            }
            return true;
        });
        return function() {
            router === null || router === void 0 ? void 0 : router.beforePopState(function() {
                return true;
            });
        };
    }
    return false;
};
function inputRegexValidation(text) {
    try {
        if (text.length === 0) {
            return false;
        }
        var regx = new RegExp("<|//|>|<iframe|http:|https:|@|$|#");
        if (regx.test(text)) {
            return false;
        }
        return true;
    } catch (e) {
        return false;
    }
}
function getFormattedDates(duration) {
    var startDateRegex = /\d{1,2} \w{3}(, \d{4})?/; // Matches day, month, and optional year pattern
    var endDateRegex = /\d{1,2} \w{3}, \d{4}/; // Matches day, month, and year pattern
    var startDateMatch = duration === null || duration === void 0 ? void 0 : duration.match(startDateRegex)[0];
    var startIndex = (duration === null || duration === void 0 ? void 0 : duration.indexOf("-")) + 1;
    var endDateMatch = duration === null || duration === void 0 ? void 0 : duration.substr(startIndex).match(endDateRegex)[0];
    var hasYear = startDateMatch === null || startDateMatch === void 0 ? void 0 : startDateMatch.includes(",");
    var startYear = hasYear ? moment__WEBPACK_IMPORTED_MODULE_0___default()(startDateMatch, "DD MMM, YYYY").format("YYYY") : moment__WEBPACK_IMPORTED_MODULE_0___default()(endDateMatch, "DD MMM, YYYY").format("YYYY");
    var endYear = moment__WEBPACK_IMPORTED_MODULE_0___default()(endDateMatch, "DD MMM, YYYY").format("YYYY");
    var startDate = moment__WEBPACK_IMPORTED_MODULE_0___default()("".concat(startDateMatch, " ").concat(startYear), "DD MMM YYYY").format("DD/MM/YYYY");
    var endDate = moment__WEBPACK_IMPORTED_MODULE_0___default()("".concat(endDateMatch, " ").concat(endYear), "DD MMM YYYY").format("DD/MM/YYYY");
    return {
        startDate: startDate !== "Invalid date" ? startDate : null,
        endDate: endDate !== "Invalid date" ? endDate : null
    };
}
var getQueryParams = function() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var utmSource = query === null || query === void 0 ? void 0 : query.utm_source;
    var singleUtmSource = "";
    var attrs = (ref = Object.keys(query).map(function(q) {
        return q !== "journeyId" && q !== "utm_source" && q !== "visaCountry" && q !== "urlRoot" ? "".concat(q, "=").concat(query[q]) : null;
    })) === null || ref === void 0 ? void 0 : ref.filter(function(a) {
        return !!a;
    });
    if (utmSource) {
        if (Array.isArray(utmSource) && (utmSource === null || utmSource === void 0 ? void 0 : utmSource.length) > 0) {
            singleUtmSource = "utm_source=".concat(utmSource[0]);
        } else singleUtmSource = "utm_source=".concat(query.utm_source);
        attrs === null || attrs === void 0 ? void 0 : attrs.push(singleUtmSource);
    }
    var params = attrs === null || attrs === void 0 ? void 0 : attrs.join("&");
    return params ? "?".concat(params) : "";
};
var getSessionQuery = function() {
    if (true) {
        // Getting previous params from session storage
        var queryString = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem("routerQuery");
        var sessionQuery = !!queryString ? JSON === null || JSON === void 0 ? void 0 : JSON.parse(queryString) : {};
        var vasQueryString = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(_segment_types__WEBPACK_IMPORTED_MODULE_1__/* .VAS.VAS_ROUTER_QUERY */ .xM.VAS_ROUTER_QUERY);
        var vasSessionQuery = !!vasQueryString ? JSON === null || JSON === void 0 ? void 0 : JSON.parse(vasQueryString) : {};
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, vasSessionQuery, sessionQuery);
    }
    return {};
};
// Login redirection
var redirectToLogin = function() {
    if (true) {
        var ref, ref1;
        var pathname = (window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.pathname) || "";
        var search = (window === null || window === void 0 ? void 0 : (ref1 = window.location) === null || ref1 === void 0 ? void 0 : ref1.search) || "";
        var nextRoute = pathname + search;
        window.location.href = "/login?next=".concat(encodeURIComponent(nextRoute));
    }
};
var convertDateToString = function(inputFormat) {
    var pad = function(s) {
        return s < 10 ? "0".concat(s) : s;
    };
    var d = new Date(inputFormat);
    return [
        pad(d.getDate()),
        pad(d.getMonth() + 1),
        d.getFullYear()
    ].join("-");
};
var getMonth = function(input) {
    var d = new Date(input);
    if (!!d) {
        var month = (d === null || d === void 0 ? void 0 : d.getMonth()) + 1;
        return month < 10 ? "0".concat(month) : month;
    }
    return "";
};
var getYear = function(input) {
    var century = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 20;
    var y = new Date(input);
    if (!!y) {
        var year = y === null || y === void 0 ? void 0 : y.getFullYear();
        return year - century * 100;
    }
    return "";
};
var getDomainHostname = function() {
    var prodUrl = "https://www.acko.com";
    var uatUrl = "https://www.ackodev.com";
    if (_api_constants__WEBPACK_IMPORTED_MODULE_2__/* .PRODUCTION_ENVIRONMENT */ .H) return prodUrl;
    return uatUrl;
};
var getAtlPrice = function() {
    var original_price = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", multiplier = arguments.length > 1 ? arguments[1] : void 0;
    var currencyFormatter = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0
    });
    var priceString = !!original_price ? original_price === null || original_price === void 0 ? void 0 : original_price.slice(1) : "";
    var filteredPrice = priceString === null || priceString === void 0 ? void 0 : priceString.replace(",", "");
    var price = !!filteredPrice ? Number(filteredPrice) : 0;
    return currencyFormatter === null || currencyFormatter === void 0 ? void 0 : currencyFormatter.format(Math.ceil(price * multiplier));
};
var getTripDurationLabel = function(selectedDateRange) {
    if ((selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.start) && (selectedDateRange === null || selectedDateRange === void 0 ? void 0 : selectedDateRange.end)) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var startDate = {
            y: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref = selectedDateRange.start) === null || ref === void 0 ? void 0 : ref.getFullYear(),
            m: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref1 = selectedDateRange.start) === null || ref1 === void 0 ? void 0 : ref1.getMonth(),
            d: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref2 = selectedDateRange.start) === null || ref2 === void 0 ? void 0 : ref2.getDate()
        };
        var endDate = {
            y: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref3 = selectedDateRange.end) === null || ref3 === void 0 ? void 0 : ref3.getFullYear(),
            m: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref4 = selectedDateRange.end) === null || ref4 === void 0 ? void 0 : ref4.getMonth(),
            d: selectedDateRange === null || selectedDateRange === void 0 ? void 0 : (ref5 = selectedDateRange.end) === null || ref5 === void 0 ? void 0 : ref5.getDate()
        };
        var label = "".concat(startDate === null || startDate === void 0 ? void 0 : startDate.d, " ").concat(src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .MONTH_SHORT_FORMS */ .Uu[startDate === null || startDate === void 0 ? void 0 : startDate.m], ", ").concat(startDate === null || startDate === void 0 ? void 0 : startDate.y, " - ").concat(endDate === null || endDate === void 0 ? void 0 : endDate.d, " ").concat(src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .MONTH_SHORT_FORMS */ .Uu[endDate === null || endDate === void 0 ? void 0 : endDate.m], ", ").concat(endDate === null || endDate === void 0 ? void 0 : endDate.y);
        if ((startDate === null || startDate === void 0 ? void 0 : startDate.y) === (endDate === null || endDate === void 0 ? void 0 : endDate.y)) {
            label = "".concat(startDate === null || startDate === void 0 ? void 0 : startDate.d, " ").concat(src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .MONTH_SHORT_FORMS */ .Uu[startDate === null || startDate === void 0 ? void 0 : startDate.m], " - ").concat(endDate === null || endDate === void 0 ? void 0 : endDate.d, " ").concat(src_common_components_date_range_common_constants__WEBPACK_IMPORTED_MODULE_4__/* .MONTH_SHORT_FORMS */ .Uu[endDate === null || endDate === void 0 ? void 0 : endDate.m], ", ").concat(endDate === null || endDate === void 0 ? void 0 : endDate.y);
        }
        return label;
    }
    return "";
};
var convertDateRange = function(dateRangeStr) {
    var ref, ref1;
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(dateRangeStr === null || dateRangeStr === void 0 ? void 0 : dateRangeStr.split(" - "), 2), startStr = ref2[0], endStr = ref2[1];
    var startDateYear = (ref = startStr === null || startStr === void 0 ? void 0 : startStr.split(",")[1]) === null || ref === void 0 ? void 0 : ref.trim();
    var endDateYear = (ref1 = endStr === null || endStr === void 0 ? void 0 : endStr.split(",")[1]) === null || ref1 === void 0 ? void 0 : ref1.trim();
    var startDate = startDateYear ? new Date(startStr) : new Date("".concat(startStr, ", ").concat(endDateYear));
    var endDate = new Date(endStr);
    return [
        startDate,
        endDate
    ];
};


/***/ }),

/***/ 49557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79354);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43126);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* eslint-disable @next/next/no-img-element */ 


var Index = function(param) {
    var code = param.code, name = param.name, sub_title = param.sub_title, price = param.price, image_url = param.image_url, evisa = param.evisa, handleClick = param.handleClick;
    var currencyFormatter = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0
    });
    var numericPrice = Number(price === null || price === void 0 ? void 0 : price.slice(2));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("section", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cardContainer),
        onClick: function() {
            return handleClick(code);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().imageContainer),
                style: {
                    backgroundImage: "url(".concat(image_url, ")")
                },
                children: evisa && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().evisaTag),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("img", {
                        src: src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .ASSETS.EVISA */ .ou.EVISA,
                        width: "28px",
                        height: "28px",
                        alt: "e-visa-tag"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("section", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cardTitle),
                        children: name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cardSubtitle),
                        children: sub_title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().priceSection),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().priceTitle),
                                children: "Starting from"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().priceValue),
                                children: !!numericPrice ? currencyFormatter === null || currencyFormatter === void 0 ? void 0 : currencyFormatter.format(numericPrice) : price
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().borderContainer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().borderImage),
                            style: {
                                background: "url(".concat(src_common_utils_config__WEBPACK_IMPORTED_MODULE_1__/* .ASSETS.V2F_CARD_BORDER */ .ou.V2F_CARD_BORDER, ")")
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Index);


/***/ }),

/***/ 95834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5047);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var ItemElement = function(param) {
    var item = param.item;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
        className: "".concat((_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().itemIcon), " ").concat(!(item === null || item === void 0 ? void 0 : item.flag) ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().hide) : ""),
        children: (item === null || item === void 0 ? void 0 : item.flag) || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().defaultName),
            children: item === null || item === void 0 ? void 0 : (ref = item.name) === null || ref === void 0 ? void 0 : ref.slice(0, 2)
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ItemElement);


/***/ }),

/***/ 72949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.loaders/dist/index.js
var dist = __webpack_require__(55158);
// EXTERNAL MODULE: ./src/common/utils/config/index.ts
var config = __webpack_require__(79354);
// EXTERNAL MODULE: ./src/vas/components/application/desktop/styles.module.scss
var styles_module = __webpack_require__(45696);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/common/utils/api/request.ts
var request = __webpack_require__(55978);
// EXTERNAL MODULE: ./src/common/utils/serverConfig/index.ts
var serverConfig = __webpack_require__(44718);
// EXTERNAL MODULE: ./src/common/utils/api/urls.ts
var urls = __webpack_require__(30207);
// EXTERNAL MODULE: ./src/common/utils/segment/types.ts
var types = __webpack_require__(19659);
// EXTERNAL MODULE: ./src/common/utils/segment/index.ts
var segment = __webpack_require__(22701);
// EXTERNAL MODULE: ./src/vas/components/application/common/flag-Icon/index.tsx
var flag_Icon = __webpack_require__(95834);
;// CONCATENATED MODULE: ./src/vas/components/application/desktop/SearchPage.tsx













var Index = function(param) {
    var _openDropdown = param.openDropdown, openDropdown = _openDropdown === void 0 ? false : _openDropdown, setOpenDropdown = param.setOpenDropdown, searchResult = param.searchResult, handleClick = param.handleClick;
    var ref;
    var ref1 = (0,compat_module.useState)(searchResult === null || searchResult === void 0 ? void 0 : (ref = searchResult.val) === null || ref === void 0 ? void 0 : ref.name), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,compat_module.useState)([]), countries = ref2[0], setCountries = ref2[1];
    var ref3 = (0,compat_module.useState)(countries), results = ref3[0], setResults = ref3[1];
    var dropdownRef = (0,compat_module.useRef)();
    (0,compat_module.useEffect)(function() {
        getCountries();
        if (true) window.addEventListener("click", handleOutsideClick);
    }, []);
    (0,compat_module.useEffect)(function() {
        if (openDropdown) (0,segment/* sendVasEvents */.J6)(types/* VasViewEvents.VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION */.lO.VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION);
    }, [
        openDropdown
    ]);
    (0,compat_module.useEffect)(function() {
        var ref;
        if (!openDropdown && !!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.val)) setSearchTerm(searchResult === null || searchResult === void 0 ? void 0 : (ref = searchResult.val) === null || ref === void 0 ? void 0 : ref.name);
    }, [
        openDropdown,
        searchResult === null || searchResult === void 0 ? void 0 : searchResult.val
    ]);
    (0,compat_module.useEffect)(function() {
        if (!!countries) {
            var searchInput = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim();
            if (!!searchInput) {
                var lowerCaseSearchTerm = searchInput === null || searchInput === void 0 ? void 0 : searchInput.toLowerCase();
                var updatedList = countries === null || countries === void 0 ? void 0 : countries.filter(function(param) {
                    var name = param.name, code = param.code;
                    var lowerCaseName = name === null || name === void 0 ? void 0 : name.toLowerCase();
                    var lowerCaseCode = code === null || code === void 0 ? void 0 : code.toLowerCase();
                    return (lowerCaseName === null || lowerCaseName === void 0 ? void 0 : lowerCaseName.startsWith(lowerCaseSearchTerm)) || (lowerCaseCode === null || lowerCaseCode === void 0 ? void 0 : lowerCaseCode.startsWith(lowerCaseSearchTerm));
                });
                setResults(updatedList);
            } else setResults(countries);
        }
    }, [
        searchTerm,
        countries
    ]);
    var getCountries = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,request/* getRequest */.A_)("".concat((0,serverConfig/* getDomainOrigin */.IY)()).concat(urls/* travelV2fUrls.getV2fCountries */.kG.getV2fCountries()))
                        ];
                    case 1:
                        res = _state.sent();
                        if (res) setCountries(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.countries);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.log({
                            error: error
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getCountries() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOutsideClick = function(e) {
        var ref;
        if ((ref = e.target) === null || ref === void 0 ? void 0 : ref.contains(dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current)) {
            setOpenDropdown(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
        ref: dropdownRef,
        onClick: handleOutsideClick,
        className: (styles_module_default()).inputContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("input", {
                className: "".concat((styles_module_default()).countrySearchInput, " ").concat(openDropdown ? (styles_module_default()).inFocusStyles : ""),
                placeholder: "Where are you planning to go?",
                type: "text",
                value: searchTerm,
                onChange: function(e) {
                    var ref;
                    return setSearchTerm(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                },
                name: "search term",
                onClick: function() {
                    return setOpenDropdown(true);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: (styles_module_default()).searchIcon,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    src: config/* ASSETS.SEARCH_ICON */.ou.SEARCH_ICON,
                    width: "16px",
                    height: "16px",
                    style: {
                        cursor: "pointer"
                    }
                })
            }),
            searchTerm && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                className: (styles_module_default()).clearIcon,
                onClick: function() {
                    setSearchTerm("");
                    handleClick({
                        country: ""
                    });
                },
                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                    src: config/* ASSETS.CLOSE_CROSS_MODAL */.ou.CLOSE_CROSS_MODAL,
                    width: "18px",
                    height: "18px",
                    style: {
                        cursor: "pointer"
                    }
                })
            }),
            openDropdown ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                className: (styles_module_default()).countryList,
                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                    className: (styles_module_default()).scrollView,
                    children: [
                        (results === null || results === void 0 ? void 0 : results.length) > 0 && (results === null || results === void 0 ? void 0 : results.map(function(c) {
                            /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: (styles_module_default()).countryName,
                                onClick: function() {
                                    handleClick({
                                        country: c === null || c === void 0 ? void 0 : c.code
                                    });
                                    setOpenDropdown(false);
                                    setSearchTerm(c === null || c === void 0 ? void 0 : c.name);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                    className: (styles_module_default()).item,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(flag_Icon/* default */.Z, {
                                            item: c
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                            children: c === null || c === void 0 ? void 0 : c.name
                                        })
                                    ]
                                })
                            }, c === null || c === void 0 ? void 0 : c.code);
                        })),
                        (results === null || results === void 0 ? void 0 : results.length) === 0 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                            className: (styles_module_default()).errorMessage,
                            children: [
                                "No results found ".concat(!!searchTerm ? "for" : ""),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("b", {
                                    children: !!searchTerm ? ' "'.concat(searchTerm, '"') : ""
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {})
        ]
    });
};
/* harmony default export */ var SearchPage = (Index);

// EXTERNAL MODULE: ./src/vas/components/application/common/Card/Index.tsx
var Card_Index = __webpack_require__(49557);
// EXTERNAL MODULE: ./src/common/styles/index.ts
var styles = __webpack_require__(31065);
// EXTERNAL MODULE: ./src/vas/config/index.ts
var vas_config = __webpack_require__(79606);
// EXTERNAL MODULE: ./src/common/custom-hooks/index.ts
var custom_hooks = __webpack_require__(49452);
// EXTERNAL MODULE: ./src/common/utils/generics/index.ts
var generics = __webpack_require__(1165);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.toast/dist/toast.js
var toast = __webpack_require__(88884);
var toast_default = /*#__PURE__*/__webpack_require__.n(toast);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
;// CONCATENATED MODULE: ./src/vas/components/application/desktop/index.tsx
/* eslint-disable @next/next/no-img-element */ /* eslint-disable jsx-a11y/media-has-caption */ 

























var desktop_Index = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var pushRoute = (0,custom_hooks/* useRouterPush */.E3)(urls/* VasFeBaseUrl */.L1);
    var ref1 = (0,compat_module.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,compat_module.useState)({
        page: 0,
        offset: 10
    }), pagination = ref2[0], setPagination = ref2[1];
    var ref3 = (0,compat_module.useState)("Trending"), selectedFilter = ref3[0], setSelectedFilter = ref3[1];
    var ref4 = (0,compat_module.useState)([]), allResults = ref4[0], setAllResults = ref4[1];
    var ref5 = (0,compat_module.useState)(null), searchResult = ref5[0], setSearchResult = ref5[1];
    var ref6 = (0,compat_module.useState)(null), showToast = ref6[0], setShowToast = ref6[1];
    var ref7 = (0,compat_module.useState)(false), openDropdown = ref7[0], setOpenDropdown = ref7[1];
    var query = (router === null || router === void 0 ? void 0 : router.query) || {};
    var ref8 = (0,compat_module.useState)(0), scrollPosition = ref8[0], setScrollPosition = ref8[1];
    (0,compat_module.useEffect)(function() {
        if (true) {
            window === null || window === void 0 ? void 0 : window.addEventListener("scroll", function() {
                var ref;
                setScrollPosition(document === null || document === void 0 ? void 0 : (ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.scrollTop);
            });
        }
    }, []);
    (0,compat_module.useEffect)(function() {
        if (!!(query === null || query === void 0 ? void 0 : query.visaCountry)) {
            var vC = query === null || query === void 0 ? void 0 : query.visaCountry;
            getSearchFilterResults({
                country: vC === null || vC === void 0 ? void 0 : vC.toUpperCase()
            }, true);
        } else {
            var p = {
                page: 0,
                offset: 10
            };
            setPagination(p);
            if (!!selectedFilter) {
                getSearchFilterResults((0,_object_spread/* default */.Z)({}, p, vas_config/* visa2FlyFilters */.Ei[selectedFilter]));
            }
        }
    }, [
        selectedFilter,
        query === null || query === void 0 ? void 0 : query.visaCountry
    ]);
    var handleCardClick = function(country) {
        setIsLoading(true);
        var userId = js_cookie/* default.get */.Z.get("user_id");
        var pathname = "".concat(urls/* VasFeBaseUrl */.L1, "/redirection/").concat(country).concat((0,generics/* getQueryParams */.vl)(query));
        (0,segment/* sendVasEvents */.J6)(types/* VasTrackEvents.TAP_BTN_COUNTRY_SELECTION */.iC.TAP_BTN_COUNTRY_SELECTION, types/* EventType.TAP */.tw.TAP, {
            destination_countries: !!country ? country : undefined
        });
        if (userId) router.push(pathname);
        else {
            router.push({
                pathname: "/login",
                query: {
                    next: pathname
                }
            });
        }
    };
    var getSearchFilterResults = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(props) {
            var isSearch, res, ref, ref1, ref2, ref3, ref4, searchedCountry, ref5, ref6, error, ref7, ref8, ref9, toastMsg;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isSearch = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,request/* postRequest */.j0)("".concat((0,serverConfig/* getDomainOrigin */.IY)()).concat(urls/* travelV2fUrls.v2fCountryResults */.kG.v2fCountryResults()), (0,_object_spread/* default */.Z)({}, props))
                        ];
                    case 2:
                        res = _state.sent();
                        setIsLoading(false);
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            setIsLoading(false);
                            if (isSearch) {
                                ;
                                searchedCountry = (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.countries) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.countries[0] : null;
                                setSearchResult(searchedCountry);
                            } else {
                                ;
                                setSearchResult(null);
                                setAllResults(res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.countries);
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setIsLoading(false);
                        console.log({
                            error: error
                        });
                        toastMsg = (error === null || error === void 0 ? void 0 : (ref7 = error.response) === null || ref7 === void 0 ? void 0 : ref7.status) === 500 ? config/* ErrorMessages.GENERIC */.XO.GENERIC : error === null || error === void 0 ? void 0 : (ref8 = error.response) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.message;
                        setShowToast(toastMsg);
                        setTimeout(function() {
                            setShowToast(null);
                            pushRoute("".concat((0,generics/* getQueryParams */.vl)(router === null || router === void 0 ? void 0 : router.query)));
                        }, 1000);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getSearchFilterResults(props) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleScroll = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var p, res, ref, ref1, error, ref2, ref3, ref4, toastMsg;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        p = {
                            page: (pagination === null || pagination === void 0 ? void 0 : pagination.page) + 1,
                            offset: 10
                        };
                        setPagination(p);
                        if (!((allResults === null || allResults === void 0 ? void 0 : allResults.length) > 9)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,request/* postRequest */.j0)("".concat((0,serverConfig/* getDomainOrigin */.IY)()).concat(urls/* travelV2fUrls.v2fCountryResults */.kG.v2fCountryResults()), (0,_object_spread/* default */.Z)({}, p, vas_config/* visa2FlyFilters */.Ei[selectedFilter]))
                        ];
                    case 2:
                        res = _state.sent();
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            ;
                            setAllResults((0,_to_consumable_array/* default */.Z)(allResults).concat((0,_to_consumable_array/* default */.Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.countries)));
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        toastMsg = (error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 500 ? config/* ErrorMessages.GENERIC */.XO.GENERIC : error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message;
                        setShowToast(toastMsg);
                        setTimeout(function() {
                            setShowToast(null);
                        }, 2000);
                        console.log({
                            error: error
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleScroll() {
            return _ref.apply(this, arguments);
        };
    }();
    var closeDropdown = function() {
        return setOpenDropdown(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* FlexContainer */.Ej, {
        styles: {
            alignItems: "flex-start"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                className: (styles_module_default()).main,
                children: [
                    isLoading && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.BasicLoader, {}),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("header", {
                        className: (styles_module_default()).headerBanner,
                        onClick: closeDropdown,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("video", {
                                width: "100%",
                                height: "100%",
                                controls: false,
                                preload: "auto",
                                muted: true,
                                autoPlay: true,
                                playsInline: true,
                                loop: true,
                                poster: config/* ASSETS.VISA_SKY_DESKTOP_POSTER */.ou.VISA_SKY_DESKTOP_POSTER,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("source", {
                                        src: config/* ASSETS.VISA_SKY_DESKTOP_VIDEO */.ou.VISA_SKY_DESKTOP_VIDEO
                                    }),
                                    "Your browser does not support the video tag."
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: (styles_module_default()).ackoLogo,
                                onClick: function() {
                                    return router === null || router === void 0 ? void 0 : router.push("/");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("img", {
                                    src: config/* ASSETS.ACKO_LOGO_DARK */.ou.ACKO_LOGO_DARK,
                                    width: "auto",
                                    height: "24px",
                                    style: {
                                        cursor: "pointer"
                                    },
                                    alt: "acko-logo"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: (styles_module_default()).headerGradient
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                        className: (styles_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                                className: (styles_module_default()).headerSection,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: (styles_module_default()).sectionSubtitle,
                                        children: "Visa made simple"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: (styles_module_default()).titleGroup,
                                        children: vas_config/* v2fTaglines */.V0 === null || vas_config/* v2fTaglines */.V0 === void 0 ? void 0 : vas_config/* v2fTaglines.map */.V0.map(function(tag) {
                                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                className: (styles_module_default()).sectionTitle,
                                                children: tag
                                            }, tag);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "".concat((styles_module_default()).searchContainer, " ").concat(scrollPosition > 300 ? (styles_module_default()).addSearchbarBackground : ""),
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SearchPage, {
                                    searchResult: {
                                        val: searchResult,
                                        set: setSearchResult
                                    },
                                    handleClick: function(param) {
                                        var _country = param.country, country = _country === void 0 ? "" : _country;
                                        (0,segment/* sendVasEvents */.J6)(types/* VasTrackEvents.TAP_BTN_COUNTRY_SEARCH */.iC.TAP_BTN_COUNTRY_SEARCH, types/* EventType.TAP */.tw.TAP, {
                                            destination_countries: !!country ? country : undefined
                                        });
                                        router === null || router === void 0 ? void 0 : router.push("".concat(urls/* VasFeBaseUrl */.L1, "/").concat(country).concat((0,generics/* getQueryParams */.vl)(query)));
                                    },
                                    openDropdown: openDropdown,
                                    setOpenDropdown: setOpenDropdown
                                })
                            }),
                            !!searchResult ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                                className: (styles_module_default()).resultContainer,
                                onClick: closeDropdown,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: (styles_module_default()).popularTitle,
                                        children: "Search result"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: (styles_module_default()).cardsContainer,
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Card_Index/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchResult), {
                                            handleClick: handleCardClick
                                        }), searchResult === null || searchResult === void 0 ? void 0 : searchResult.code)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                                className: (styles_module_default()).resultContainer,
                                onClick: closeDropdown,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        className: (styles_module_default()).pageTitle,
                                        children: "Pick where you’d like to go"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("section", {
                                        className: (styles_module_default()).filters,
                                        children: (ref = Object.keys(vas_config/* visa2FlyFilters */.Ei)) === null || ref === void 0 ? void 0 : ref.map(function(filter) {
                                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                className: "".concat((styles_module_default()).filterPill, " ").concat(selectedFilter === filter ? (styles_module_default()).filterIsActive : ""),
                                                onClick: function() {
                                                    if (selectedFilter !== filter) {
                                                        setSelectedFilter(filter);
                                                        (0,segment/* sendVasEvents */.J6)(types/* VasTrackEvents.TAP_BTN_COUNTRY_SEARCH_FILTER */.iC.TAP_BTN_COUNTRY_SEARCH_FILTER, types/* EventType.TAP */.tw.TAP, {
                                                            category: selectedFilter
                                                        });
                                                    }
                                                },
                                                children: filter
                                            }, filter);
                                        })
                                    }),
                                    !isLoading && (allResults === null || allResults === void 0 ? void 0 : allResults.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("section", {
                                        className: (styles_module_default()).noResult,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                                src: config/* ASSETS.GRAY_FALLEN_GLASS */.ou.GRAY_FALLEN_GLASS,
                                                width: "80px",
                                                height: "80px"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                className: (styles_module_default()).noResultsText,
                                                children: "Couldn’t find any result"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_es/* default */.Z, {
                                            dataLength: allResults === null || allResults === void 0 ? void 0 : allResults.length,
                                            next: function() {
                                                return handleScroll();
                                            },
                                            hasMore: true,
                                            loader: false,
                                            children: (allResults === null || allResults === void 0 ? void 0 : allResults.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                                className: (styles_module_default()).cardsContainer,
                                                onClick: closeDropdown,
                                                children: allResults === null || allResults === void 0 ? void 0 : allResults.map(function(card) {
                                                    /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(Card_Index/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, card), {
                                                        handleClick: handleCardClick
                                                    }), card === null || card === void 0 ? void 0 : card.code);
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!showToast && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((toast_default()), {
                toastMessage: showToast,
                toastType: "error"
            })
        ]
    });
};
/* harmony default export */ var desktop = (desktop_Index);


/***/ }),

/***/ 93703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mobile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.loaders/dist/index.js
var dist = __webpack_require__(55158);
// EXTERNAL MODULE: ./src/common/utils/config/index.ts
var config = __webpack_require__(79354);
// EXTERNAL MODULE: ./src/vas/components/application/mobile/styles.tsx
var styles = __webpack_require__(70292);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.modal/dist/index.js
var building_blocks_ui_modal_dist = __webpack_require__(75251);
// EXTERNAL MODULE: ./src/common/utils/responsive/index.tsx
var responsive = __webpack_require__(7010);
// EXTERNAL MODULE: ./src/common/utils/api/request.ts
var request = __webpack_require__(55978);
// EXTERNAL MODULE: ./src/common/utils/serverConfig/index.ts
var serverConfig = __webpack_require__(44718);
// EXTERNAL MODULE: ./src/common/utils/api/urls.ts
var urls = __webpack_require__(30207);
// EXTERNAL MODULE: ./src/common/utils/segment/types.ts
var types = __webpack_require__(19659);
// EXTERNAL MODULE: ./src/common/utils/segment/index.ts
var segment = __webpack_require__(22701);
// EXTERNAL MODULE: ./src/vas/components/application/common/flag-Icon/index.tsx
var flag_Icon = __webpack_require__(95834);
;// CONCATENATED MODULE: ./src/vas/components/application/mobile/SearchPage.tsx















var Index = function(param) {
    var searchResult = param.searchResult, handleClick = param.handleClick;
    var ref;
    var ref1 = (0,compat_module.useState)(searchResult === null || searchResult === void 0 ? void 0 : (ref = searchResult.val) === null || ref === void 0 ? void 0 : ref.name), searchTerm = ref1[0], setSearchTerm = ref1[1];
    var ref2 = (0,compat_module.useState)(false), openModal = ref2[0], setOpenModal = ref2[1];
    var ref3 = (0,compat_module.useState)(false), inFocus = ref3[0], setInFocus = ref3[1];
    var ref4 = (0,compat_module.useState)([]), countries = ref4[0], setCountries = ref4[1];
    var ref5 = (0,compat_module.useState)(countries), results = ref5[0], setResults = ref5[1];
    (0,compat_module.useEffect)(function() {
        getCountries();
    }, []);
    (0,compat_module.useEffect)(function() {
        if (openModal) (0,segment/* sendVasEvents */.J6)(types/* VasViewEvents.VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION */.lO.VIEW_MODAL_VISA_ASSISTANCE_COUNTRY_SELECTION);
    }, [
        openModal
    ]);
    (0,compat_module.useEffect)(function() {
        var ref;
        if (!openModal && !!(searchResult === null || searchResult === void 0 ? void 0 : searchResult.val)) setSearchTerm(searchResult === null || searchResult === void 0 ? void 0 : (ref = searchResult.val) === null || ref === void 0 ? void 0 : ref.name);
    }, [
        openModal,
        searchResult === null || searchResult === void 0 ? void 0 : searchResult.val
    ]);
    (0,compat_module.useEffect)(function() {
        if (!!countries) {
            var searchInput = searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.trim();
            if (!!searchInput) {
                var lowerCaseSearchTerm = searchInput === null || searchInput === void 0 ? void 0 : searchInput.toLowerCase();
                var updatedList = countries === null || countries === void 0 ? void 0 : countries.filter(function(param) {
                    var name = param.name, code = param.code;
                    var lowerCaseName = name === null || name === void 0 ? void 0 : name.toLowerCase();
                    var lowerCaseCode = code === null || code === void 0 ? void 0 : code.toLowerCase();
                    return (lowerCaseName === null || lowerCaseName === void 0 ? void 0 : lowerCaseName.startsWith(lowerCaseSearchTerm)) || (lowerCaseCode === null || lowerCaseCode === void 0 ? void 0 : lowerCaseCode.startsWith(lowerCaseSearchTerm));
                });
                setResults(updatedList);
            } else setResults(countries);
        }
    }, [
        searchTerm,
        countries
    ]);
    var getCountries = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, res, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,request/* getRequest */.A_)("".concat((0,serverConfig/* getDomainOrigin */.IY)()).concat(urls/* travelV2fUrls.getV2fCountries */.kG.getV2fCountries()))
                        ];
                    case 1:
                        res = _state.sent();
                        if (res) setCountries(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.countries);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        console.log({
                            error: error
                        });
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function getCountries() {
            return _ref.apply(this, arguments);
        };
    }();
    var renderModal = function() {
        var isMobile = (0,responsive/* useViewport */.S)().isMobile;
        var Modal = isMobile ? building_blocks_ui_modal_dist.ModalMobile : building_blocks_ui_modal_dist.ModalDesktop;
        return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Modal, {
            show: openModal,
            onHide: function() {
                setInFocus(false);
                setOpenModal(false);
            },
            wrapperStyles: "border-radius: 24px 24px 0px 0px;",
            showOverlayBackground: true,
            urlhash: "",
            header: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* BoldText */.xW, {
                padding: "unset",
                children: "Select a country"
            }),
            padding: "32px 20px",
            minWidth: isMobile ? "" : "400px",
            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* SearchBar */.E1, {
                        focus: inFocus,
                        children: [
                            !inFocus && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                src: config/* ASSETS.SEARCH_ICON */.ou.SEARCH_ICON,
                                width: "18px",
                                height: "18px",
                                style: {
                                    cursor: "pointer"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* Input */.II, {
                                focus: inFocus,
                                placeholder: "Search country",
                                type: "text",
                                value: searchTerm,
                                onChange: function(e) {
                                    var ref;
                                    return setSearchTerm(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : ref.value);
                                },
                                onFocus: function() {
                                    return setInFocus(true);
                                },
                                onBlur: function() {
                                    return setInFocus(false);
                                }
                            }),
                            searchTerm && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* ClearIcon */.Rk, {
                                onClick: function() {
                                    setSearchTerm("");
                                    handleClick({
                                        country: ""
                                    });
                                    searchResult === null || searchResult === void 0 ? void 0 : searchResult.set(null);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    src: config/* ASSETS.CLOSE_CROSS_MODAL */.ou.CLOSE_CROSS_MODAL,
                                    width: "18px",
                                    height: "18px",
                                    style: {
                                        cursor: "pointer"
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* CountryList */.TZ, {
                        children: [
                            (results === null || results === void 0 ? void 0 : results.length) > 0 && (results === null || results === void 0 ? void 0 : results.map(function(c) {
                                /*#__PURE__*/ return (0,jsx_runtime/* jsxs */.BX)(styles/* Item */.ck, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(flag_Icon/* default */.Z, {
                                            item: c
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* CountryName */.i6, {
                                            onClick: function() {
                                                handleClick({
                                                    country: c === null || c === void 0 ? void 0 : c.code
                                                });
                                                setInFocus(false);
                                                setOpenModal(false);
                                                setSearchTerm(c === null || c === void 0 ? void 0 : c.name);
                                            },
                                            children: c === null || c === void 0 ? void 0 : c.name
                                        }, c === null || c === void 0 ? void 0 : c.code)
                                    ]
                                }, c === null || c === void 0 ? void 0 : c.name);
                            })),
                            (results === null || results === void 0 ? void 0 : results.length) === 0 && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* ErrorMessage */.Bc, {
                                children: [
                                    "No results found ".concat(!!searchTerm ? "for" : ""),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("b", {
                                        children: !!searchTerm ? ' "'.concat(searchTerm, '"') : ""
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(jsx_runtime/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* Searchbar */.wD, {
                onClick: function() {
                    setOpenModal(!openModal);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                        src: config/* ASSETS.SEARCH_ICON */.ou.SEARCH_ICON,
                        width: "16px",
                        height: "16px",
                        style: {
                            cursor: "pointer"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* SearchText */.wh, {
                        children: searchTerm || "Where are you planning to go?"
                    })
                ]
            }),
            renderModal()
        ]
    });
};
/* harmony default export */ var SearchPage = (Index);

// EXTERNAL MODULE: ./src/vas/components/application/common/Card/Index.tsx
var Card_Index = __webpack_require__(49557);
// EXTERNAL MODULE: ./src/common/styles/index.ts
var common_styles = __webpack_require__(31065);
// EXTERNAL MODULE: ./src/vas/config/index.ts
var vas_config = __webpack_require__(79606);
// EXTERNAL MODULE: ./src/common/custom-hooks/index.ts
var custom_hooks = __webpack_require__(49452);
// EXTERNAL MODULE: ./src/common/utils/generics/index.ts
var generics = __webpack_require__(1165);
// EXTERNAL MODULE: ./node_modules/@acko-tech/building-blocks.ui.toast/dist/toast.js
var toast = __webpack_require__(88884);
var toast_default = /*#__PURE__*/__webpack_require__.n(toast);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
;// CONCATENATED MODULE: ./src/vas/components/application/mobile/index.tsx
/* eslint-disable jsx-a11y/media-has-caption */ 

























var mobile_Index = function() {
    var ref;
    var router = (0,next_router.useRouter)();
    var pushRoute = (0,custom_hooks/* useRouterPush */.E3)(urls/* VasFeBaseUrl */.L1);
    var ref1 = (0,compat_module.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,compat_module.useState)({
        page: 0,
        offset: 10
    }), pagination = ref2[0], setPagination = ref2[1];
    var ref3 = (0,compat_module.useState)("Trending"), selectedFilter = ref3[0], setSelectedFilter = ref3[1];
    var ref4 = (0,compat_module.useState)([]), allResults = ref4[0], setAllResults = ref4[1];
    var ref5 = (0,compat_module.useState)(null), searchResult = ref5[0], setSearchResult = ref5[1];
    var ref6 = (0,compat_module.useState)(null), showToast = ref6[0], setShowToast = ref6[1];
    var query = (router === null || router === void 0 ? void 0 : router.query) || {};
    (0,compat_module.useEffect)(function() {
        if (!!(query === null || query === void 0 ? void 0 : query.visaCountry)) {
            var vC = query === null || query === void 0 ? void 0 : query.visaCountry;
            getSearchFilterResults({
                country: vC === null || vC === void 0 ? void 0 : vC.toUpperCase()
            }, true);
        } else {
            var p = {
                page: 0,
                offset: 10
            };
            setPagination(p);
            if (!!selectedFilter) {
                getSearchFilterResults((0,_object_spread/* default */.Z)({}, p, vas_config/* visa2FlyFilters */.Ei[selectedFilter]));
            }
        }
    }, [
        selectedFilter,
        query === null || query === void 0 ? void 0 : query.visaCountry
    ]);
    var handleCardClick = function(country) {
        setIsLoading(true);
        var userId = js_cookie/* default.get */.Z.get("user_id");
        var pathname = "".concat(urls/* VasFeBaseUrl */.L1, "/redirection/").concat(country).concat((0,generics/* getQueryParams */.vl)(query));
        (0,segment/* sendVasEvents */.J6)(types/* VasTrackEvents.TAP_BTN_COUNTRY_SELECTION */.iC.TAP_BTN_COUNTRY_SELECTION, types/* EventType.TAP */.tw.TAP, {
            destination_countries: !!country ? country : undefined
        });
        if (userId) router.push(pathname);
        else {
            router.push({
                pathname: "/login",
                query: {
                    next: pathname
                }
            });
        }
    };
    var getSearchFilterResults = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(props) {
            var isSearch, res, ref, ref1, ref2, ref3, ref4, searchedCountry, ref5, ref6, error, ref7, ref8, ref9, toastMsg;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isSearch = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,request/* postRequest */.j0)("".concat((0,serverConfig/* getDomainOrigin */.IY)()).concat(urls/* travelV2fUrls.v2fCountryResults */.kG.v2fCountryResults()), (0,_object_spread/* default */.Z)({}, props))
                        ];
                    case 2:
                        res = _state.sent();
                        setIsLoading(false);
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            if (isSearch) {
                                ;
                                searchedCountry = (res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.countries) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 ? res === null || res === void 0 ? void 0 : (ref3 = res.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.countries[0] : null;
                                setSearchResult(searchedCountry);
                            } else {
                                ;
                                setSearchResult(null);
                                setAllResults(res === null || res === void 0 ? void 0 : (ref5 = res.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.data) === null || ref6 === void 0 ? void 0 : ref6.countries);
                            }
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        setIsLoading(false);
                        console.log({
                            error: error
                        });
                        toastMsg = (error === null || error === void 0 ? void 0 : (ref7 = error.response) === null || ref7 === void 0 ? void 0 : ref7.status) === 500 ? config/* ErrorMessages.GENERIC */.XO.GENERIC : error === null || error === void 0 ? void 0 : (ref8 = error.response) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.data) === null || ref9 === void 0 ? void 0 : ref9.message;
                        setShowToast(toastMsg);
                        setTimeout(function() {
                            setShowToast(null);
                            pushRoute("".concat((0,generics/* getQueryParams */.vl)(router === null || router === void 0 ? void 0 : router.query)));
                        }, 1000);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getSearchFilterResults(props) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleScroll = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var p, res, ref, ref1, error, ref2, ref3, ref4, toastMsg;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        p = {
                            page: (pagination === null || pagination === void 0 ? void 0 : pagination.page) + 1,
                            offset: 10
                        };
                        setPagination(p);
                        if (!((allResults === null || allResults === void 0 ? void 0 : allResults.length) > 9)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,request/* postRequest */.j0)("".concat((0,serverConfig/* getDomainOrigin */.IY)()).concat(urls/* travelV2fUrls.v2fCountryResults */.kG.v2fCountryResults()), (0,_object_spread/* default */.Z)({}, p, vas_config/* visa2FlyFilters */.Ei[selectedFilter]))
                        ];
                    case 2:
                        res = _state.sent();
                        if (res === null || res === void 0 ? void 0 : res.data) {
                            ;
                            setAllResults((0,_to_consumable_array/* default */.Z)(allResults).concat((0,_to_consumable_array/* default */.Z)(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.countries)));
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        toastMsg = (error === null || error === void 0 ? void 0 : (ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 500 ? config/* ErrorMessages.GENERIC */.XO.GENERIC : error === null || error === void 0 ? void 0 : (ref3 = error.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.message;
                        setShowToast(toastMsg);
                        setTimeout(function() {
                            setShowToast(null);
                        }, 2000);
                        console.log({
                            error: error
                        });
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleScroll() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleBack = function() {
        setIsLoading(true);
        (0,segment/* sendVasEvents */.J6)(types/* TravelInsuranceTrackEvents.TAP_BTN_INT_BACK */.G$.TAP_BTN_INT_BACK, types/* EventType.TAP */.tw.TAP);
        setTimeout(function() {
            var ref, ref1;
            if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.utm_medium) === vas_config/* UTM_MEDIUM_HOMEPAGE */.HT || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.utm_medium) === vas_config/* UTM_MEDIUM_EXPLORE_TAB */.lh) router === null || router === void 0 ? void 0 : router.push("/myaccount");
            else router === null || router === void 0 ? void 0 : router.back();
        }, 200);
    };
    return /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(common_styles/* FlexContainer */.Ej, {
        styles: {
            alignItems: "flex-start",
            maxWidth: "480px"
        },
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(dist.BasicLoader, {}),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* HeaderBanner */.bj, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("video", {
                        width: "100%",
                        height: "100%",
                        controls: false,
                        muted: true,
                        autoPlay: true,
                        playsInline: true,
                        loop: true,
                        poster: config/* ASSETS.V2F_HEAD_IMAGE */.ou.V2F_HEAD_IMAGE,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("source", {
                                src: config/* ASSETS.SKY_VIDEO */.ou.SKY_VIDEO
                            }),
                            "Your browser does not support the video tag."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* BackIcon */.xC, {
                        onClick: function() {
                            return handleBack();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                            src: config/* ASSETS.BACK_ARROW */.ou.BACK_ARROW,
                            width: "24px",
                            height: "24px",
                            style: {
                                cursor: "pointer"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* Gradient */.ph, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* Section */.$0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* PageContainer */._z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* SectionSubtitle */.Vq, {
                                children: "Visa made simple"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* TitleGroup */.L$, {
                                children: vas_config/* v2fTaglines */.V0 === null || vas_config/* v2fTaglines */.V0 === void 0 ? void 0 : vas_config/* v2fTaglines.map */.V0.map(function(tag) {
                                    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* SectionTitle */.NZ, {
                                        children: tag
                                    }, tag);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(SearchPage, {
                                searchResult: {
                                    val: searchResult,
                                    set: setSearchResult
                                },
                                handleClick: function(param) {
                                    var _country = param.country, country = _country === void 0 ? "" : _country;
                                    (0,segment/* sendVasEvents */.J6)(types/* VasTrackEvents.TAP_BTN_COUNTRY_SEARCH */.iC.TAP_BTN_COUNTRY_SEARCH, types/* EventType.TAP */.tw.TAP, {
                                        destination_countries: !!country ? country : undefined
                                    });
                                    router === null || router === void 0 ? void 0 : router.push("".concat(urls/* VasFeBaseUrl */.L1, "/").concat(country).concat((0,generics/* getQueryParams */.vl)(query)));
                                }
                            })
                        ]
                    }),
                    !!searchResult ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* PageContainer */._z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PopularTitle */.cA, {
                                    children: "Search result"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(Card_Index/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchResult), {
                                    handleClick: handleCardClick
                                }), searchResult === null || searchResult === void 0 ? void 0 : searchResult.code)
                            ]
                        })
                    }) : !isLoading && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                        children: (allResults === null || allResults === void 0 ? void 0 : allResults.length) === 0 ? /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* NoResult */.xM, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((image_default()), {
                                    src: config/* ASSETS.GRAY_FALLEN_GLASS */.ou.GRAY_FALLEN_GLASS,
                                    width: "80px",
                                    height: "80px",
                                    alt: "back"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* NoResultsText */.Ai, {
                                    children: "Couldn’t find any result"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(jsx_runtime/* Fragment */.HY, {
                            children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(styles/* PageContainer */._z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* PopularTitle */.cA, {
                                        children: "Pick where you’d like to go"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* Filters */.x$, {
                                        children: (ref = Object.keys(vas_config/* visa2FlyFilters */.Ei)) === null || ref === void 0 ? void 0 : ref.map(function(filter) {
                                            return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* FilterPill */.Bm, {
                                                active: selectedFilter === filter,
                                                onClick: function() {
                                                    if (selectedFilter !== filter) {
                                                        setSelectedFilter(filter);
                                                        (0,segment/* sendVasEvents */.J6)(types/* VasTrackEvents.TAP_BTN_COUNTRY_SEARCH_FILTER */.iC.TAP_BTN_COUNTRY_SEARCH_FILTER, types/* EventType.TAP */.tw.TAP, {
                                                            category: filter
                                                        });
                                                    }
                                                },
                                                children: filter
                                            }, filter);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(index_es/* default */.Z, {
                                        dataLength: allResults === null || allResults === void 0 ? void 0 : allResults.length,
                                        next: function() {
                                            return handleScroll();
                                        },
                                        hasMore: true,
                                        loader: false,
                                        children: (allResults === null || allResults === void 0 ? void 0 : allResults.length) > 0 && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(styles/* CardsContainer */.oR, {
                                            children: allResults === null || allResults === void 0 ? void 0 : allResults.map(function(card) {
                                                /*#__PURE__*/ return (0,jsx_runtime/* jsx */.tZ)(Card_Index/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, card), {
                                                    handleClick: handleCardClick
                                                }), card === null || card === void 0 ? void 0 : card.code);
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            !!showToast && /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)((toast_default()), {
                toastMessage: showToast,
                toastType: "error"
            })
        ]
    });
};
/* harmony default export */ var mobile = (mobile_Index);


/***/ }),

/***/ 79606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ visa2FlyFilters; },
/* harmony export */   "HT": function() { return /* binding */ UTM_MEDIUM_HOMEPAGE; },
/* harmony export */   "V0": function() { return /* binding */ v2fTaglines; },
/* harmony export */   "lh": function() { return /* binding */ UTM_MEDIUM_EXPLORE_TAB; }
/* harmony export */ });
/* unused harmony exports tempCards, visaDiscounts */
/* harmony import */ var src_common_utils_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79354);

var UTM_MEDIUM_HOMEPAGE = "homepage";
var UTM_MEDIUM_EXPLORE_TAB = "explore_tab";
var visa2FlyFilters = {
    Trending: {
        popular: true
    },
    "Visa in 1 week": {
        maxDays: 7
    }
};
var v2fTaglines = [
    "End-to-end assistance",
    "9 out of 10 visas on time",
    "Real-time tracking", 
];
var tempCards = [
    {
        code: "ML",
        name: "Malaysia",
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.BAGGAGE_DELAY */ .ou.BAGGAGE_DELAY,
        price: "₹4,400",
        sub_title: "Processing time 1-2 business days",
        evisa: true
    },
    {
        code: "ET",
        name: "Egypt",
        image_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.FLIGHT_DELAY */ .ou.FLIGHT_DELAY,
        price: "₹8,100",
        sub_title: "Processing time 3-4 business days",
        evisa: false
    }, 
];
var visaDiscounts = [
    {
        icon_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.YELLOW_DISCOUNT */ .ou.YELLOW_DISCOUNT,
        title: "Get <b>₹500 off</b> on your visa application",
        subtitle: "Use code <b>ACKO500</b> for transactions above ₹5499"
    },
    {
        icon_url: src_common_utils_config__WEBPACK_IMPORTED_MODULE_0__/* .ASSETS.YELLOW_DISCOUNT */ .ou.YELLOW_DISCOUNT,
        title: "Get <b>₹1000 off</b> on your visa application",
        subtitle: "Use code <b>ACKO1000</b> for transactions above ₹18,999"
    }, 
];


/***/ }),

/***/ 43126:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__zYvSn","imageContainer":"styles_imageContainer__3kvZG","content":"styles_content__m6uJ_","cardTitle":"styles_cardTitle__z0Y7F","cardSubtitle":"styles_cardSubtitle__38ES9","priceTitle":"styles_priceTitle__gGYV5","priceValue":"styles_priceValue__lvoz6","borderContainer":"styles_borderContainer__iBTQL","borderImage":"styles_borderImage__rYzix","evisaTag":"styles_evisaTag__l6NDG","priceSection":"styles_priceSection__7j_LE"};

/***/ }),

/***/ 5047:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"itemIcon":"styles_itemIcon__VW4oh","defaultName":"styles_defaultName__Q1DZf","hide":"styles_hide__M3zM4"};

/***/ }),

/***/ 45696:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__aZk17","sectionTitle":"styles_sectionTitle__bfOuX","sectionTitleSlideUp":"styles_sectionTitleSlideUp__bhckh","pageTitle":"styles_pageTitle__FVHtX","item":"styles_item__KuSJ5","sectionSubtitle":"styles_sectionSubtitle__lmJ5L","noResultsText":"styles_noResultsText__TMwk8","popularCountriesSection":"styles_popularCountriesSection__cyAII","popularTitle":"styles_popularTitle__GZdvG","headerGradient":"styles_headerGradient__Iumpa","filters":"styles_filters__qtKMn","filterPill":"styles_filterPill__WUazb","filterIsActive":"styles_filterIsActive__CnBul","ackoLogo":"styles_ackoLogo__jp0tH","cardsContainer":"styles_cardsContainer__jnxvv","searchText":"styles_searchText__gxhhE","boldText":"styles_boldText__0RPKr","tracker":"styles_tracker__2FEP1","primaryText":"styles_primaryText__XUgSn","secondaryText":"styles_secondaryText__afHpZ","noteSection":"styles_noteSection__mqsZa","note":"styles_note__RPksH","separator":"styles_separator__fQgEA","benefitsContainer":"styles_benefitsContainer__229NS","benefitsSection":"styles_benefitsSection__iDWvA","benefits":"styles_benefits__452GJ","benefit":"styles_benefit__wjn1X","footer":"styles_footer__HGSK1","footerCta":"styles_footerCta__GUQJM","secondaryCta":"styles_secondaryCta__EuxMJ","mandatoryNudge":"styles_mandatoryNudge__Sgkod","searchBar":"styles_searchBar__txBKf","searchInput":"styles_searchInput__zdROj","countrySearchInput":"styles_countrySearchInput__9HNbV","backIconContainer":"styles_backIconContainer__C5C1P","clearIcon":"styles_clearIcon__cLn_l","countryList":"styles_countryList__Ol5Wj","scrollView":"styles_scrollView__Ar8nE","countryName":"styles_countryName__lFAdk","errorMessage":"styles_errorMessage__RM27P","titleGroup":"styles_titleGroup__DW8Cy","noResult":"styles_noResult__N8bL_","headerBanner":"styles_headerBanner__g8KDh","uspList":"styles_uspList__aWn6v","flightImageContainer":"styles_flightImageContainer__HWouR","headerSection":"styles_headerSection__Mb_ux","resultContainer":"styles_resultContainer___Ataa","searchContainer":"styles_searchContainer__HgCJP","inputContainer":"styles_inputContainer__E_6DB","addSearchbarBackground":"styles_addSearchbarBackground___6U90","searchIcon":"styles_searchIcon__14F_H","inFocusStyles":"styles_inFocusStyles__EEyyo","content":"styles_content__1xv77"};

/***/ }),

/***/ 58533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {Number}    delay          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {Boolean}   [noTrailing]   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset)
 * @param  {Function}  callback       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {Boolean}   [debounceMode] If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @return {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    var self = this;
    var elapsed = Date.now() - lastExec;
    var args = arguments;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, args);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

var ThresholdUnits = {
    Pixel: 'Pixel',
    Percent: 'Percent',
};
var defaultThreshold = {
    unit: ThresholdUnits.Percent,
    value: 0.8,
};
function parseThreshold(scrollThreshold) {
    if (typeof scrollThreshold === 'number') {
        return {
            unit: ThresholdUnits.Percent,
            value: scrollThreshold * 100,
        };
    }
    if (typeof scrollThreshold === 'string') {
        if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) {
            return {
                unit: ThresholdUnits.Pixel,
                value: parseFloat(scrollThreshold),
            };
        }
        if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) {
            return {
                unit: ThresholdUnits.Percent,
                value: parseFloat(scrollThreshold),
            };
        }
        console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
        return defaultThreshold;
    }
    console.warn('scrollThreshold should be string or number');
    return defaultThreshold;
}

var InfiniteScroll = /** @class */ (function (_super) {
    __extends(InfiniteScroll, _super);
    function InfiniteScroll(props) {
        var _this = _super.call(this, props) || this;
        _this.lastScrollTop = 0;
        _this.actionTriggered = false;
        // variables to keep track of pull down behaviour
        _this.startY = 0;
        _this.currentY = 0;
        _this.dragging = false;
        // will be populated in componentDidMount
        // based on the height of the pull down element
        _this.maxPullDownDistance = 0;
        _this.getScrollableTarget = function () {
            if (_this.props.scrollableTarget instanceof HTMLElement)
                return _this.props.scrollableTarget;
            if (typeof _this.props.scrollableTarget === 'string') {
                return document.getElementById(_this.props.scrollableTarget);
            }
            if (_this.props.scrollableTarget === null) {
                console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
            }
            return null;
        };
        _this.onStart = function (evt) {
            if (_this.lastScrollTop)
                return;
            _this.dragging = true;
            if (evt instanceof MouseEvent) {
                _this.startY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.startY = evt.touches[0].pageY;
            }
            _this.currentY = _this.startY;
            if (_this._infScroll) {
                _this._infScroll.style.willChange = 'transform';
                _this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
            }
        };
        _this.onMove = function (evt) {
            if (!_this.dragging)
                return;
            if (evt instanceof MouseEvent) {
                _this.currentY = evt.pageY;
            }
            else if (evt instanceof TouchEvent) {
                _this.currentY = evt.touches[0].pageY;
            }
            // user is scrolling down to up
            if (_this.currentY < _this.startY)
                return;
            if (_this.currentY - _this.startY >=
                Number(_this.props.pullDownToRefreshThreshold)) {
                _this.setState({
                    pullToRefreshThresholdBreached: true,
                });
            }
            // so you can drag upto 1.5 times of the maxPullDownDistance
            if (_this.currentY - _this.startY > _this.maxPullDownDistance * 1.5)
                return;
            if (_this._infScroll) {
                _this._infScroll.style.overflow = 'visible';
                _this._infScroll.style.transform = "translate3d(0px, " + (_this.currentY -
                    _this.startY) + "px, 0px)";
            }
        };
        _this.onEnd = function () {
            _this.startY = 0;
            _this.currentY = 0;
            _this.dragging = false;
            if (_this.state.pullToRefreshThresholdBreached) {
                _this.props.refreshFunction && _this.props.refreshFunction();
                _this.setState({
                    pullToRefreshThresholdBreached: false,
                });
            }
            requestAnimationFrame(function () {
                // this._infScroll
                if (_this._infScroll) {
                    _this._infScroll.style.overflow = 'auto';
                    _this._infScroll.style.transform = 'none';
                    _this._infScroll.style.willChange = 'unset';
                }
            });
        };
        _this.onScrollListener = function (event) {
            if (typeof _this.props.onScroll === 'function') {
                // Execute this callback in next tick so that it does not affect the
                // functionality of the library.
                setTimeout(function () { return _this.props.onScroll && _this.props.onScroll(event); }, 0);
            }
            var target = _this.props.height || _this._scrollableNode
                ? event.target
                : document.documentElement.scrollTop
                    ? document.documentElement
                    : document.body;
            // return immediately if the action has already been triggered,
            // prevents multiple triggers.
            if (_this.actionTriggered)
                return;
            var atBottom = _this.props.inverse
                ? _this.isElementAtTop(target, _this.props.scrollThreshold)
                : _this.isElementAtBottom(target, _this.props.scrollThreshold);
            // call the `next` function in the props to trigger the next data fetch
            if (atBottom && _this.props.hasMore) {
                _this.actionTriggered = true;
                _this.setState({ showLoader: true });
                _this.props.next && _this.props.next();
            }
            _this.lastScrollTop = target.scrollTop;
        };
        _this.state = {
            showLoader: false,
            pullToRefreshThresholdBreached: false,
            prevDataLength: props.dataLength,
        };
        _this.throttledOnScrollListener = throttle(150, _this.onScrollListener).bind(_this);
        _this.onStart = _this.onStart.bind(_this);
        _this.onMove = _this.onMove.bind(_this);
        _this.onEnd = _this.onEnd.bind(_this);
        return _this;
    }
    InfiniteScroll.prototype.componentDidMount = function () {
        if (typeof this.props.dataLength === 'undefined') {
            throw new Error("mandatory prop \"dataLength\" is missing. The prop is needed" +
                " when loading more content. Check README.md for usage");
        }
        this._scrollableNode = this.getScrollableTarget();
        this.el = this.props.height
            ? this._infScroll
            : this._scrollableNode || window;
        if (this.el) {
            this.el.addEventListener('scroll', this
                .throttledOnScrollListener);
        }
        if (typeof this.props.initialScrollY === 'number' &&
            this.el &&
            this.el instanceof HTMLElement &&
            this.el.scrollHeight > this.props.initialScrollY) {
            this.el.scrollTo(0, this.props.initialScrollY);
        }
        if (this.props.pullDownToRefresh && this.el) {
            this.el.addEventListener('touchstart', this.onStart);
            this.el.addEventListener('touchmove', this.onMove);
            this.el.addEventListener('touchend', this.onEnd);
            this.el.addEventListener('mousedown', this.onStart);
            this.el.addEventListener('mousemove', this.onMove);
            this.el.addEventListener('mouseup', this.onEnd);
            // get BCR of pullDown element to position it above
            this.maxPullDownDistance =
                (this._pullDown &&
                    this._pullDown.firstChild &&
                    this._pullDown.firstChild.getBoundingClientRect()
                        .height) ||
                    0;
            this.forceUpdate();
            if (typeof this.props.refreshFunction !== 'function') {
                throw new Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
            }
        }
    };
    InfiniteScroll.prototype.componentWillUnmount = function () {
        if (this.el) {
            this.el.removeEventListener('scroll', this
                .throttledOnScrollListener);
            if (this.props.pullDownToRefresh) {
                this.el.removeEventListener('touchstart', this.onStart);
                this.el.removeEventListener('touchmove', this.onMove);
                this.el.removeEventListener('touchend', this.onEnd);
                this.el.removeEventListener('mousedown', this.onStart);
                this.el.removeEventListener('mousemove', this.onMove);
                this.el.removeEventListener('mouseup', this.onEnd);
            }
        }
    };
    InfiniteScroll.prototype.componentDidUpdate = function (prevProps) {
        // do nothing when dataLength is unchanged
        if (this.props.dataLength === prevProps.dataLength)
            return;
        this.actionTriggered = false;
        // update state when new data was sent in
        this.setState({
            showLoader: false,
        });
    };
    InfiniteScroll.getDerivedStateFromProps = function (nextProps, prevState) {
        var dataLengthChanged = nextProps.dataLength !== prevState.prevDataLength;
        // reset when data changes
        if (dataLengthChanged) {
            return __assign(__assign({}, prevState), { prevDataLength: nextProps.dataLength });
        }
        return null;
    };
    InfiniteScroll.prototype.isElementAtTop = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop <=
                threshold.value + clientHeight - target.scrollHeight + 1);
        }
        return (target.scrollTop <=
            threshold.value / 100 + clientHeight - target.scrollHeight + 1);
    };
    InfiniteScroll.prototype.isElementAtBottom = function (target, scrollThreshold) {
        if (scrollThreshold === void 0) { scrollThreshold = 0.8; }
        var clientHeight = target === document.body || target === document.documentElement
            ? window.screen.availHeight
            : target.clientHeight;
        var threshold = parseThreshold(scrollThreshold);
        if (threshold.unit === ThresholdUnits.Pixel) {
            return (target.scrollTop + clientHeight >= target.scrollHeight - threshold.value);
        }
        return (target.scrollTop + clientHeight >=
            (threshold.value / 100) * target.scrollHeight);
    };
    InfiniteScroll.prototype.render = function () {
        var _this = this;
        var style = __assign({ height: this.props.height || 'auto', overflow: 'auto', WebkitOverflowScrolling: 'touch' }, this.props.style);
        var hasChildren = this.props.hasChildren ||
            !!(this.props.children &&
                this.props.children instanceof Array &&
                this.props.children.length);
        // because heighted infiniteScroll visualy breaks
        // on drag down as overflow becomes visible
        var outerDivStyle = this.props.pullDownToRefresh && this.props.height
            ? { overflow: 'auto' }
            : {};
        return (react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("div", { style: outerDivStyle, className: "infinite-scroll-component__outerdiv" },
            react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("div", { className: "infinite-scroll-component " + (this.props.className || ''), ref: function (infScroll) { return (_this._infScroll = infScroll); }, style: style },
                this.props.pullDownToRefresh && (react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("div", { style: { position: 'relative' }, ref: function (pullDown) { return (_this._pullDown = pullDown); } },
                    react__WEBPACK_IMPORTED_MODULE_0__["default"].createElement("div", { style: {
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: -1 * this.maxPullDownDistance,
                        } }, this.state.pullToRefreshThresholdBreached
                        ? this.props.releaseToRefreshContent
                        : this.props.pullDownToRefreshContent))),
                this.props.children,
                !this.state.showLoader &&
                    !hasChildren &&
                    this.props.hasMore &&
                    this.props.loader,
                this.state.showLoader && this.props.hasMore && this.props.loader,
                !this.props.hasMore && this.props.endMessage)));
    };
    return InfiniteScroll;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component));

/* harmony default export */ __webpack_exports__["Z"] = (InfiniteScroll);
//# sourceMappingURL=index.es.js.map


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

}]);